module.exports = __webpack_public_path__ + "img/tb-7.cf1cca69.png";